import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { apiError } from "@/lib/marketing";
import { CampaignCheckbox } from "@/components/admin/marketing/CampaignCheckbox";

export const PublishDialog = ({ item, onClose, onDone }) => {
  const [mode, setMode] = useState("now");
  const [when, setWhen] = useState("");
  const [busy, setBusy] = useState(false);
  const [sendEmail, setSendEmail] = useState(!!item.email_requested);
  const [limitMsg, setLimitMsg] = useState(null);

  const submit = async () => {
    setBusy(true);
    try {
      setLimitMsg(null);
      const base = { mode, send_email: sendEmail };
      const body = mode === "now" ? base : { ...base, publish_at: new Date(when).toISOString() };
      const r = await api.post(`/admin/marketing/contents/${item.id}/publish`, body);
      toast.success(mode === "now" ? "Pubblicato" : "Pubblicazione programmata");
      onDone(r.data);
    } catch (err) {
      if (err?.response?.data?.detail?.code === "CAMPAIGN_LIMIT_REACHED") {
        setLimitMsg(err.response.data.detail.message);
        setSendEmail(false);
      } else toast.error(apiError(err, "Data non valida"));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="publish-dialog">
      <div className="bg-white rounded-[12px] w-full max-w-md p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-[#0A0A0A]">Pubblica «{item.title}»</h3>
          <button onClick={onClose} data-testid="publish-close"><X size={18} /></button>
        </div>
        <label className="flex items-center gap-2 text-sm"><input type="radio" checked={mode === "now"} onChange={() => setMode("now")} data-testid="publish-mode-now" /> Pubblica subito</label>
        <label className="flex items-center gap-2 text-sm"><input type="radio" checked={mode === "schedule"} onChange={() => setMode("schedule")} data-testid="publish-mode-schedule" /> Programma</label>
        {mode === "schedule" && (
          <input type="datetime-local" className="vg-input" value={when} onChange={(e) => setWhen(e.target.value)} data-testid="publish-datetime" />
        )}
        <CampaignCheckbox item={item} sendAt={mode === "schedule" && when ? new Date(when) : null}
          checked={sendEmail} onChange={setSendEmail} testid="publish-campaign" />
        {limitMsg && <p className="text-xs font-semibold text-[#B40101] bg-red-50 rounded-[8px] p-3" data-testid="publish-limit-msg">{limitMsg}</p>}
        <p className="text-xs text-gray-500">Il contenuto compare comunque nella dashboard dei PA abilitati. Massimo 2 campagne email al mese (ora italiana). In Preview le email sono solo simulate.</p>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="vg-btn-secondary px-4 py-2 text-sm">Annulla</button>
          <button onClick={submit} disabled={busy || (mode === "schedule" && !when)} className="vg-btn-primary px-5 py-2 text-sm" data-testid="publish-confirm">Conferma</button>
        </div>
      </div>
    </div>
  );
};
